<template>
  <FormInput
    class="FormPercentageInput"
    content-wrapper-class="d-flex"
    type="number"
    v-bind="{...$attrs, ...$props}"
    v-on="$listeners"
    min="0" max="100"
  >
    <template #after>
      <span class="currency-wrapper d-flex justify-content-center align-items-center flex-shrink-0">
        %
      </span>
    </template>
  </FormInput>
</template>

<script>

import FormInput from "./FormInput.vue"

import { props } from "./FormFieldWrapper.vue"

export default {
  props: { ...props },
  components: {
    FormInput,
  },
}

</script>

<style scoped>

.currency-wrapper {
  background-color: #F6F6F6;
  width: 35px;
  border: 1px solid #bebfc1;
  border-left: none;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

</style>

<style>

.FormPercentageInput input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
